import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import RegisterFinalizeForm from './Components/RegisterFinalizeForm';
import LoginPageWrapper from '../Components/LoginPageWrapper';

import './RegisterFinalize.scss';

function RegisterFinalize(props) {
  const { init, resetState } = props;

  useEffect(() => {
    init();
    return () => {
      resetState();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <LoginPageWrapper className="react-page-register-finalize-page">
      <RegisterFinalizeForm {...props} />
    </LoginPageWrapper>
  );
}

RegisterFinalize.propTypes = {
  init: PropTypes.func.isRequired,
  resetState: PropTypes.func.isRequired,
};

export default RegisterFinalize;
